// Webpack Imports
import * as bootstrap from 'bootstrap';


( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );
} )();

// Header scroll
window.onscroll = function() {headerScroll()};
function headerScroll() {
  if (document.documentElement.scrollTop > 50) {
    document.getElementById("header_wrapper").classList.add("sticky");
  } else {
    document.getElementById("header_wrapper").classList.remove("sticky");
  }
}

// Menu opener
document.getElementById("menu_opener").onclick = function(e) { openMenu(e); }
document.getElementById("menu_opener_mobile").onclick = function(e) { openMenu(e); }
function openMenu(e) {
    document.getElementById("header").classList.add("menu_visible");
    document.getElementById("body").classList.add("overflowed");
    document.querySelector("html").classList.add("overflowed");
    e.currentTarget.parentElement.classList.add("opened");
}
document.getElementById("menu_closer").onclick = function(e) { closeMenu(e); }
document.getElementById("menu_closer_mobile").onclick = function(e) { closeMenu(e); }
function closeMenu(e) {
    document.getElementById("header").classList.remove("menu_visible");
    document.getElementById("body").classList.remove("overflowed");
    document.querySelector("html").classList.remove("overflowed");
    e.currentTarget.parentElement.classList.remove("opened");
}

const menuItems = document.querySelectorAll("ul.upper_level_nav li.menu-item-has-children");
for (let i = 0; i < menuItems.length; i++) {
    menuItems[i].onclick = function(e){ menuClick(e); }
}
function menuClick(e){
    e.preventDefault;
    e.currentTarget.parentElement.classList.add("expanded");
    e.currentTarget.classList.add("clicked");
    e.currentTarget.removeEventListener("click", menuClick);
    e.currentTarget.addEventListener("click", menuBack);
}
function menuBack(e){
    e.preventDefault;
    e.currentTarget.parentElement.classList.remove("expanded");
    e.currentTarget.classList.remove("clicked");
    e.currentTarget.removeEventListener("click", menuBack);
    e.currentTarget.addEventListener("click", menuClick);
}

// Deactivate void links
var links = document.getElementsByTagName("a");
for(var i=0; i<links.length; i++) {
    var link = links[i].getAttribute("href");
    if ( link == '#' ){
        links[i].classList.add("disabled");
    }
}

$(document).ready(function(){

    // Unwrap p tags in headings
    $("h1 > p").each(function () {
        if ( $(this).parent().hasClass('text') ){
            $(this).parent().removeClass('text').addClass('text_tag');
        }
        $(this).replaceWith($(this).html() + "<br/>");
    });
    $("h2 > p").each(function () {
        if ( $(this).parent().hasClass('text') ){
            $(this).parent().removeClass('text').addClass('text_tag');
        }
        $(this).replaceWith($(this).html() + "<br/>");
    });
    $("h3 > p").each(function () {
        if ( $(this).parent().hasClass('text') ){
            $(this).parent().removeClass('text').addClass('text_tag');
        }
        $(this).replaceWith($(this).html() + "<br/>");
    });
    $("h4 > p").each(function () {
        if ( $(this).parent().hasClass('text') ){
            $(this).parent().removeClass('text').addClass('text_tag');
        }
        $(this).replaceWith($(this).html() + "<br/>");
    });
    
    // Init OwlCarousel
    $('.owl-carousel').owlCarousel({
        loop:true,
        margin: 10,
        responsive:{
            0:{
                items:2
            },
            992:{
                items:3
            }
        }
    })
});